import list from './list'
import orgSummary from './orgSummary'
import externalSummary from './externalSummary'

export default {
    list,
    orgSummary,
    externalSummary
}